angular.module('impactx.controlstructure').component('ixBasketControlStructureInput', {
        bindings: {
            data: '<',
            required: '<',
            trns: '<',
            saveBasket: '&?',
            name: '@',
            helperDialogParams: "<",
            parentControlLabel: "<",
            basketControlLabel: "<",
            fractionSize: "="
        },
        controller: 'BasketControlStructureInputCtrl',
        controllerAs: 'controlInputCtrl',
        require: {
            formCtrl: '^form'
        },
        templateUrl: 'modules/control/templates/basket-control-structure-input.tmpl.html',
    }
);